<template>
    <label class="custom-radio mr-2">
        <input 
            type="radio" 
            :checked="isChecked"
            :value="value" 
            @change="handleChange"
        />
        <span class="custom-radio__circle"></span>
    </label>
</template>

<script>
export default {
    props: {
        isChecked: {
            type: Boolean,
            default: false
        },
        onChange: {
            type: Function,
            default: () => { }
        },
        value: {
            type: null
        }
    },
    methods: {
        handleChange() {
            this.onChange()
        }
    }
};
</script>

<style scoped lang="scss">
input[type="radio"] {
    position: absolute;
    opacity: 0;
}

.custom-radio {
    height: 20px;

    &__circle {
        display: inline-block;
        width: 20px;
        height: 20px;
        border: 2px solid #4a4a4a;
        border-radius: 50%;
        transition: background-color 0.3s, border-color 0.3s;
        position: relative;
    }
}

input[type="radio"]:checked+.custom-radio__circle {
    border-color: var(--accent-color);

    &::before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: var(--accent-color);
        transform: translate(-50%, -50%);
    }
}

.custom-radio__circle:hover {
    border-color: var(--accent-color);
}
</style>